import type { FaireProductEntity } from "../../entity_types/product";

export const p_gazpvcjbxz: FaireProductEntity = {
  token: "p_gazpvcjbxz",
  type: "product",
  name: "The Gold Goddess Tea Strainer - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/f98ffc14f912b0fbb61e8e2b1739cb3daa0f3c92a6a578e0f9e3f160a64768d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7faa80aa8cd43222919df958f0feca6664391a83986490208cd2ebefeecb5da.jpeg",
    "https://cdn.faire.com/fastly/46b011117a79d7ae9d05c6d56de71e86fcfcfc7f8c70f3c43250e624624ceb76.jpeg",
    "https://cdn.faire.com/fastly/613ff6bd84f8e82b5f32945b20ee6fbdf641c26c7ff52433940cf11791edc628.jpeg"
  ],
  priceDollars: 11,
  description: " Steep & sip the perfect cup with this fine mesh tea infuser. \n\nBrew the perfect cup of tea with this stunning Gold Goddess Tea Strainer. The infuser basket is large enough to let the loose tea mingle and infuse flavour, with a fine strain to capture all the little bits. The lid doubles as a handy resting place for the steeper after use.\n\n\nTo Use: Simply spoon 1 tsp of Lake & Oak Tea per 1 cup of water into the infuser. Pour boiling water over the tea laves, and steep for your desired amount of time. Sip and soak up the bliss. ",
  tags: [],
  msrpDollars: 16.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:41.667Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
